import "jquery";
import _, { toLower } from "lodash";
import "./calendar.scss";
import "bootstrap";
import "popper.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";
import moment from "moment";
import { Loader, LoaderOptions, google } from "google-maps";

import sponsors from "../sponsors";
import { faFontAwesome } from "@fortawesome/free-brands-svg-icons";
import { faArrowLeft, faDiceFour } from "@fortawesome/free-solid-svg-icons";
import "../coffee.main.scss";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const loader = new Loader("AIzaSyCJAsF8wG2Htu0D99PtIgAiA3fVW2ORQF8", {});
let default_latitude = 25.6771627;
let default_longitude = -100.3666328;

var moment_today = moment();
var moment_current = moment_today.clone();
var moment_today_2 = moment();
var events = [];
var map = null;

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle("Calendario", page_template_header_title);

//main content
let row = document.createElement("div");
row.classList.add("row");
row.classList.add("calendar_container");
let col_1 = document.createElement("div");
col_1.classList.add("col-lg-6", "col-md-6", "col-sm-12");
let col_2 = document.createElement("div");
col_2.classList.add("col-lg-6", "col-md-6", "col-sm-12");
col_1.id = "js__calendar_container";

row.appendChild(col_1);
row.appendChild(col_2);

// place the game detail container
let events_detail = document.createElement("div");
events_detail.id = "js__calendar_event_detail";
events_detail.style.visibility = "hidden";
events_detail.classList.add(
  "cs_content",
  "cs_detail",
  "row",
  "col-sm-12",
  "col-lg-12",
  "col-md-12",
  "cs_content"
);

let events_detail_row_1 = document.createElement("div");
events_detail_row_1.classList.add("row");

let events_detail_row_2 = document.createElement("div");
events_detail_row_2.classList.add("row");

let events_detail_row_3 = document.createElement("div");
events_detail_row_3.classList.add("row");

events_detail.appendChild(events_detail_row_1);
events_detail.appendChild(events_detail_row_2);
events_detail.appendChild(events_detail_row_3);

//this will be inserted on the first row "scoreboard"
let scoreboard = document.createElement("div");
scoreboard.classList.add("cs_scoreboard");

let scoreboard_div = document.createElement("div");
scoreboard_div.classList.add("cs_opacity_75", "cs_color_4");

scoreboard.appendChild(scoreboard_div);

let wrapper = document.createElement("div");
wrapper.classList.add("cs_wrapper");

let wrapper_span = document.createElement("span");
wrapper_span.id = "lbl_vs";
wrapper_span.classList.add("cs_button");
wrapper_span.innerText = "VS";

wrapper.appendChild(wrapper_span);

let wrapper_table = document.createElement("table");
let wrapper_table_tr = document.createElement("tr");

wrapper_table.appendChild(wrapper_table_tr);

let wrapper_table_td_1 = document.createElement("td");
let wrapper_table_td_2 = document.createElement("td");

let img_logo_1 = document.createElement("img");
img_logo_1.id = "img_logo_1";
let img_logo_2 = document.createElement("img");
img_logo_2.id = "img_logo_2";

wrapper_table_td_1.appendChild(img_logo_1);
wrapper_table_td_2.appendChild(img_logo_2);

wrapper_table_tr.appendChild(wrapper_table_td_1);
wrapper_table_tr.appendChild(wrapper_table_td_2);

wrapper.appendChild(wrapper_table);

events_detail_row_1.appendChild(wrapper);

//second row events_detail_row_2
let events_detail_row_2_col_1 = document.createElement("div");
events_detail_row_2_col_1.classList.add("col-sm-6", "cs_detail_map");

let events_detail_row_2_col_1_div = document.createElement("div");
events_detail_row_2_col_1_div.id = "div_map";
events_detail_row_2_col_1_div.classList.add(
  "div_map",
  "row",
  "col-sm-12",
  "col-lg-12",
  "clearfix"
);
events_detail_row_2_col_1.appendChild(events_detail_row_2_col_1_div);

let events_detail_row_2_col_1_a = document.createElement("a");
events_detail_row_2_col_1_a.id = "btn_map";
events_detail_row_2_col_1_a.classList.add(
  "btn",
  "btn-dark",
  "cs_button",
  "row",
  "col-sm-12",
  "col-lg-12"
);
events_detail_row_2_col_1_a.innerText = "Ver mapa";

events_detail_row_2_col_1.appendChild(events_detail_row_2_col_1_a);

events_detail_row_2.appendChild(events_detail_row_2_col_1);

//second column
let events_detail_row_2_col_2 = document.createElement("div");
events_detail_row_2_col_2.classList.add("col-sm-6", "cs_detail_text");

let events_detail_row_2_col_2_div = document.createElement("div");
events_detail_row_2_col_2_div.classList.add("div_description");

let events_detail_row_2_col_2_p = document.createElement("p");
events_detail_row_2_col_2_p.classList.add("cs_small");
events_detail_row_2_col_2_p.innerHTML =
  'Del: <span id="lbl_date_start">---</span><br> \
Al: <span id="lbl_date_end">---</span><br> \
Hora: <span id="lbl_time_start">---</span> a <span id="lbl_time_end">---</span><br> \
En: <span id="lbl_venue">---</span>';

events_detail_row_2_col_2_div.appendChild(events_detail_row_2_col_2_p);
events_detail_row_2_col_2.appendChild(events_detail_row_2_col_2_div);
events_detail_row_2.appendChild(events_detail_row_2_col_2);

//second row events_detail_row_2

let buttons = [
  // { id: "btn_stats", class: "fi-graph-bar", text: "Minuto a minuto", href:"" },
  { id: "btn_live", class: "fi-video", text: "Ver en vivo" },
  { id: "btn_phone", class: "fi-telephone", text: "Contacto" },
  { id: "btn_web", class: "fi-monitor", text: "Web" }
];

buttons.forEach((item) => {
  let div = document.createElement("div");
  div.classList.add("col-md-4", "mx-auto");

  let a = document.createElement("a");
  a.id = item.id;
  a.classList.add("button", "games_links");

  let i = document.createElement("i");
  i.innerHTML = item.text;
  i.classList.add(item.class, "btn", "btn-dark");
  i.prepend(document.createElement("br"));

  div.appendChild(a);
  a.appendChild(i);
  a.href = item.href;
  a.classList.add("cs_disabled");
  events_detail_row_3.appendChild(div);
});

col_2.appendChild(events_detail);

page_template_content.appendChild(row);

//place the game list container
let events_list = document.createElement("div");
events_list.id = "js__calendar_event_list";
page_template_content.appendChild(events_list);

//banner
page_template_content.appendChild(displayTopBanner(base_url, 32));

//news LNBP contigo
page_template_content.appendChild(displayLNBPContigo(base_url));

//page_footer
page_footer.render(base_url, id_season);

//sponsors
sponsors.displaySponsors(page_template_content);

//render the calendar after the calendar container has been append
buildCalendar(moment_today);

//hide loader at the end, always at the bottom of this index file
$(window).on("load", function () {
  page_template.hideLoader();
});

//news
function displayNewsType2(news, div_element, base_url) {
  let container = document.createElement("div");
  container.style.paddingBottom = "1rem";
  container.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      window.location.href = "news.html?news_id=" + news.id;
    },
    true
  );

  let img = document.createElement("img");
  img.src = base_url + news.full_url_image;

  let title = document.createElement("span");
  title.innerHTML = news.name.slice(0, 30) + "...";
  title.classList.add("news_type_2_title");

  let line = document.createElement("hr");

  let description = document.createElement("span");
  description.textContent =
    news.description.replace(/<\/?[^>]+(>|$)/g, " ").slice(0, 60) + "...";

  let date = document.createElement("span");
  date.innerHTML = news.created_at.slice(0, 10);
  date.classList.add("news_type_2_date");

  container.appendChild(img);
  container.appendChild(title);
  container.appendChild(line);
  container.appendChild(description);
  container.appendChild(date);

  div_element.appendChild(container);
}

function displayLNBPContigo(base_url) {
  let container = document.createElement("div");

  coffee_main.createSectionTitle("LNBP Contigo", container, true, "news.html");

  let row_1 = document.createElement("div");
  row_1.classList.add("row");

  let row_1_col_1 = document.createElement("div");
  row_1_col_1.classList.add("col-sm-12", "col-md-4", "col-lg-4", "news_type_2");

  let row_1_col_2 = document.createElement("div");
  row_1_col_2.classList.add("col-sm-6", "col-md-4", "col-lg-4", "news_type_2");

  let row_1_col_3 = document.createElement("div");
  row_1_col_3.classList.add("col-sm-6", "col-md-4", "col-lg-4", "news_type_2");

  row_1.appendChild(row_1_col_1);
  row_1.appendChild(row_1_col_2);
  row_1.appendChild(row_1_col_3);

  let row_2 = document.createElement("div");
  row_2.classList.add("row");

  let row_2_col_1 = document.createElement("div");
  row_2_col_1.classList.add("col-sm-12", "col-md-4", "col-lg-4", "news_type_2");

  let row_2_col_2 = document.createElement("div");
  row_2_col_2.classList.add("col-sm-12", "col-md-4", "col-lg-4", "news_type_2");

  let row_2_col_3 = document.createElement("div");
  row_2_col_3.classList.add("col-sm-12", "col-md-4", "col-lg-4", "news_type_2");

  row_2.appendChild(row_2_col_1);
  row_2.appendChild(row_2_col_2);
  row_2.appendChild(row_2_col_3);

  container.appendChild(row_1);
  container.appendChild(row_2);

  var ajax_data = {
    count: 6
  };
  $.ajax({
    type: "POST",
    url: base_url + "/communication/news/all",
    data: ajax_data
  }).done(function (response) {
    if (response.items[0]) {
      displayNewsType2(response.items[0], row_1_col_1, base_url);
    }
    if (response.items[1]) {
      displayNewsType2(response.items[1], row_1_col_2, base_url);
    }
    if (response.items[2]) {
      displayNewsType2(response.items[2], row_1_col_3, base_url);
    }
    if (response.items[3]) {
      displayNewsType2(response.items[3], row_2_col_1, base_url);
    }
    if (response.items[4]) {
      displayNewsType2(response.items[4], row_2_col_2, base_url);
    }
    if (response.items[5]) {
      displayNewsType2(response.items[5], row_2_col_3, base_url);
    }
  });

  return container;
}

/* Banner */
function displayTopBanner(base_url, id_entry) {
  //Prepare the request data.
  var ajax_data = {
    id: id_entry
  };

  let image_container = document.createElement("div");
  image_container.classList.add("text-center", "banner_center");

  $.ajax({
    type: "POST",
    url: base_url + "/cms/entries/single",
    data: ajax_data
  }).done(function (response) {
    let image = document.createElement("img");
    image.src = base_url + response.item.full_url_image;
    if (
      response.item.full_url_image != null &&
      !response.item.full_url_image.includes("no-image.jpg")
    ) {
      image_container.appendChild(image);
    }
  });

  return image_container;
}

function buildCalendar(moment) {
  //clean the calendar
  document.getElementById("js__calendar_container").innerHTML = "";
  var moment_start = moment.startOf("month").clone();
  var moment_end = moment.endOf("month").clone();

  //this is html_row_1
  let header_tr = document.createElement("tr");
  let header_td_title = document.createElement("td");
  header_td_title.innerText = moment.format("MMMM YYYY");
  header_td_title.colSpan = 5;
  header_tr.appendChild(header_td_title);

  let header_td_prev = document.createElement("td");
  header_td_prev.id = "cs_previous_month";
  let header_td_prev_arrow = document.createElement("span");
  header_td_prev_arrow.classList.add(
    "fas",
    "fa-arrow-left",
    "cs_previous_month",
    "cs_previous_month"
  );
  header_td_prev.appendChild(header_td_prev_arrow);
  // header_td_prev.style.width = "100%";
  // header_td_prev.style.paddingTop = "40%";

  // header_td_prev.appendChild(document.createElement("div"));

  header_tr.appendChild(header_td_prev);

  // header_td_next.style.width = "100%";
  // header_td_next.style.paddingTop = "40%";

  let header_td_next = document.createElement("td");
  header_td_next.id = "cs_next_month";
  let header_td_next_arrow = document.createElement("span");
  header_td_next_arrow.classList.add(
    "fas",
    "fa-arrow-right",
    "cs_next_month",
    "cs_next_month"
  );
  header_td_next.appendChild(header_td_next_arrow);
  header_tr.appendChild(header_td_next);

  //this is html_row_2
  let sub_header_tr = document.createElement("tr");
  ["DOM", "LUN", "MAR", "MIER", "JUE", "VIE", "SAB"].map((item) => {
    let td = document.createElement("td");
    td.innerText = item;
    sub_header_tr.appendChild(td);
  });

  let calendar_table = document.createElement("table");

  calendar_table.appendChild(header_tr);
  calendar_table.appendChild(sub_header_tr);

  var moment_curr = moment_start.clone();

  let calendar_table_tr = document.createElement("tr");

  //Fill out the days before the start of the month.
  if (moment_curr.day() > 0) {
    while (moment_curr.day() > 0) {
      //paints day as grey meaning or showing past month days
      moment_curr.subtract(1, "days");

      let td = document.createElement("td");
      td.id = moment_curr.format("YYYY-MM-DD");
      td.classList.add("cs_day", "cs_day", "cs_om", "cs_om");
      td.innerText = moment_curr.format("D");
      calendar_table_tr.prepend(td);
    }

    moment_curr = moment_start.clone();
  }

  //Fill out the days of the month. all gray
  while (moment_curr.isBefore(moment_end)) {
    let td = document.createElement("td");
    td.id = moment_curr.format("YYYY-MM-DD");
    td.classList.add("cs_day", "cs_day");
    td.innerText = moment_curr.format("D");
    calendar_table_tr.appendChild(td);
    moment_curr.add(1, "days");

    //creates the calendar rows
    if (moment_curr.day() === 0 && moment_curr.isBefore(moment_end)) {
      // html_all += "</tr><tr>";
      calendar_table.appendChild(calendar_table_tr);
      calendar_table_tr = document.createElement("tr");
    }
  }
  calendar_table.appendChild(calendar_table_tr);

  //Fill out the days after the end of the month.
  if (moment_curr.day() <= 6) {
    var html_after = "";

    while (moment_curr.day() !== 0) {
      let td = document.createElement("td");
      td.id = moment_curr.format("YYYY-MM-DD");
      td.classList.add("cs_day", "cs_day", "cs_om", "cs_om");
      td.innerText = moment_curr.format("D");
      calendar_table_tr.append(td);
      moment_curr.add(1, "days");
    }
  }
  calendar_table.classList.add("cs_calendar", "cs_calendar");
  calendar_table.id = "tbl_calendar";
  calendar_table.align = "center";
  //Adjust row height.
  var height = $(".cs_day").height();
  var width = $(".cs_day").width();

  if (height > width) {
    $(".cs_day").width($(".cs_day").height());
  } else {
    //$(".cs_day").height($(".cs_day").width());
  }

  loadGames(moment_start, moment_end);

  document.getElementById("js__calendar_container").appendChild(calendar_table);

  //Setup event hooks after the calendar has been appended
  $(".cs_day").on("click", function () {
    var date = $(this).attr("id");
    cs_load_game_list(date, date).then((response) => {
      let news_list_container = document.querySelector(
        "#js__calendar_event_list"
      );
      news_list_container.innerHTML = "";
      news_list_container.appendChild(response);
    });

    //scroll to the calendar list
    document
      .getElementById("js__calendar_event_list")
      .scrollIntoView({ behavior: "smooth", block: "center" });
  });

  $("#cs_previous_month").on("click", function (e) {
    moment_current.subtract(1, "months");
    buildCalendar(moment_current);
  });

  $("#cs_next_month").on("click", function (e) {
    moment_current.add(1, "months");
    buildCalendar(moment_current);
  });
}

//paints the date
function loadGames(date_start, date_end) {
  //Prepare the request data.
  var ajax_data = {
    date_start: date_start.format("YYYY_MM-DD"),
    date_end: date_end.format("YYYY_MM-DD")
  };

  $.ajax({
    type: "POST",
    url: base_url + "/sports/games/dates",
    data: ajax_data
  }).done(function (response) {
    //Repeat the events for the dates they occur.
    $.each(response.items, function (i, item) {
      var date_start = moment(item.event.date_start, "YYYY-MM-DD");
      var date_end = moment(item.event.date_end, "YYYY-MM-DD");
      var date_curr = date_start.clone();

      while (date_curr.isBefore(date_end) || date_curr.isSame(date_end)) {
        $("#tbl_calendar #" + date_curr.format("YYYY-MM-DD")).addClass(
          "cs_has_event"
        );
        date_curr.add(1, "days");
      }
    });
  });
}

function cs_load_game(id_game) {
  if (id_game != null) {
    var ajax_data = {
      id: id_game
    };

    $.ajax({
      type: "POST",
      url: base_url + "/sports/games/single",
      data: ajax_data
    }).done(function (response) {
      $("#img_logo_1").attr(
        "src",
        base_url + response.item.team_1.full_url_logo
      );
      $("#img_logo_2").attr(
        "src",
        base_url + response.item.team_2.full_url_logo
      );
      $("#lbl_description").html(response.item.description);
      $("#lbl_date_start").text(
        moment(response.item.event.date_start, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        )
      );
      $("#lbl_date_end").text(
        moment(response.item.event.date_end, "YYYY-MM-DD").format("DD/MM/YYYY")
      );
      $("#lbl_time_start").text(
        moment(response.item.event.time_start, "HH:mm:ss").format("hh:mma")
      );
      $("#lbl_time_end").text(
        moment(response.item.event.time_end, "HH:mm:ss").format("hh:mma")
      );
      $("#lbl_venue").text(response.item.event.venue);

      if (response.item.url_live !== "") {
        $("#btn_live").attr("href", "live.html");
        $("#btn_live").removeClass("cs_disabled");
      } else {
        $("#btn_live").addClass("cs_disabled");
        $("#btn_live").attr("href", "#");
      }

      if (response.item.event.phone !== "") {
        $("#btn_phone").on("click", function () {
          window.location = "tel:" + response.item.event.phone;
        });
        $("#btn_phone").removeClass("cs_disabled");
      } else {
        $("#btn_phone").attr("href", "#");
        $("#btn_phone").addClass("cs_disabled");
      }

      if (response.item.event.website !== "") {
        let url =
          response.item.event.website.indexOf("http") > -1
            ? response.item.event.website
            : "https://" + response.item.event.website;

        $("#btn_web").href =
          response.item.event.website.indexOf("http") > -1
            ? response.item.event.website
            : "https://" + response.item.event.website;

        $("#btn_web").removeClass("cs_disabled");
      } else {
        $("#btn_web").addClass("cs_disabled");
        $("#btn_web").attr("href", "#");
      }

      if (response.item.event.address !== null) {
        $("#lbl_address").text(response.item.event.address.name);

        //Click events for buttons.
        $(".map").on("click", function () {
          return false;
        });
        $("#btn_map").on("click", function () {
          cs_track_event_click_map(cs_get_url_parameter("id"));
          cs_redirect(
            "https://maps.google.com/?q=" +
              response.item.event.address.latitude +
              "," +
              response.item.event.address.longitude +
              "&z=13"
          );
        });

        var mapOptions = {
          center: {
            lat: parseFloat(response.item.event.address.latitude),
            lng: parseFloat(response.item.event.address.longitude)
          },
          zoom: 12,
          disableDefaultUI: true,
          draggable: false,
          zoomControl: false,
          scaleControl: false,
          scrollwheel: false,
          disableDoubleClickZoom: true
        };

        loader.load().then(function (google) {
          const map = new google.maps.Map(
            document.getElementById("div_map"),
            mapOptions
          );

          //Place an initial marker.
          var latitude = parseFloat(response.item.event.address.latitude);
          var longitude = parseFloat(response.item.event.address.longitude);
          var coordinates = new google.maps.LatLng(latitude, longitude);
          var marker = new google.maps.Marker({
            position: coordinates,
            map: map
          });

          //Define pin properties
          var pinColor = "AD172B";
          var pinIcon = new google.maps.MarkerImage(
            "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|" +
              pinColor,
            null,
            null,
            null,
            new google.maps.Size(10, 17)
          );

          marker.setIcon(pinIcon);
          map.panTo(coordinates);
          $("#calendar").find(".title").html("Detalle de Juego");
          $("#btn_back").show();
          $("#div_detail").show();
          $("#div_calendar").hide();
          $("#div_map").show();
          $("#btn_map").show();
        });
      } else {
        $("#div_map").hide();
        $("#btn_map").hide();
        $("#calendar").find(".title").html("Detalle de Juego");
        $("#btn_back").show();
        $("#div_detail").show();
        $("#div_calendar").hide();
        //$(".cs_detail_text.columns").removeClass("small-6").addClass("small-12");
      }

      $("html, body").animate(
        {
          scrollTop: 0
        },
        500
      );

      //Setup the share message.
      //cs_set_share_message("Viendo el juego de " + response.item.team_1.name + " vs. " + response.item.team_2.name + " en la aplicación de " + app_title + ".");
    });
  }

  events_detail.style.visibility = "";
}

async function cs_load_game_list(date_start, date_end) {
  if (date_start !== undefined) {
    let response = await cs_load_games_dates(date_start, date_end).then(
      (response) => {
        return cs_render_game_list(response, date_start, date_end);
      }
    );
    return response;
  } else {
    let response = await cs_load_games_all().then((response) => {
      return cs_render_game_list(response);
    });
    return response;
  }
}

async function cs_load_games_all() {
  //Prepare the request data.
  var ajax_data = {};

  return $.ajax({
    type: "POST",
    url: base_url + "/sports/games/active",
    data: ajax_data
  });
}

async function cs_load_games_dates(date_start, date_end) {
  //Prepare the request data.
  var ajax_data = {
    date_start: date_start,
    date_end: date_end
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/sports/games/dates",
    data: ajax_data
  });
}

//tbbm: understand this and paint events on list
async function cs_render_game_list(response, query_date_start, query_date_end) {
  // $("#div_list").html("");
  let div_list = document.createElement("div");
  div_list.id = "div_list";

  if (response.items.length > 0) {
    var events = [];
    //Repeat the events for the dates they occur.
    $.each(response.items, function (i, item) {
      var venue = item.event.venue;
      var date_start = moment(item.event.date_start, "YYYY-MM-DD");
      var date_end = moment(item.event.date_end, "YYYY-MM-DD");
      var time_start = moment(item.event.time_start, "hh:mm:ss");
      var time_end = moment(item.event.time_end, "hh:mm:ss");
      var date_curr = date_start;
      var url_live = item.url_live;

      while (date_curr.isBefore(date_end) || date_curr.isSame(date_end)) {
        if (typeof query_date_start === "undefined") {
          events.push({
            id: item.id,
            name: item.name,
            date: date_curr.clone(),
            time_start: time_start,
            time_end: time_end,
            full_url_logo_1: item.team_1.full_url_logo,
            full_url_logo_2: item.team_2.full_url_logo,
            venue: venue,
            url_live: item.url_live
          });
        } else {
          if (
            date_curr.isBefore(query_date_start) ||
            date_curr.isAfter(query_date_end)
          ) {
            //Do nothing.
          } else {
            events.push({
              id: item.id,
              name: item.name,
              date: date_curr.clone(),
              time_start: time_start,
              time_end: time_end,
              full_url_logo_1: item.team_1.full_url_logo,
              full_url_logo_2: item.team_2.full_url_logo,
              venue: venue,
              url_live: item.url_live
            });
          }
        }

        date_curr.add(1, "days");
      }
    });

    //Sort the events.
    events.sort(function (a, b) {
      if (a.date.isBefore(b.date, "day")) return -1;
      if (b.date.isBefore(a.date, "day")) return 1;
      return 0;
    });

    //Display the events.
    $.each(events, function (i, item) {
      var selector_2 = $("#div_" + item.date.format("YYYY-MM-DD"));

      if (selector_2.length === 0) {
        let link = "";
        let linkClass = ["button", "small", "cs_disabled"];

        if (item.url_live != "") {
          link = item.url_live;
          linkClass = ["button", "small"];
        }

        var day_name = item.date.format("DD/MM/YYYY");
        // $("#div_list").append("<div id='div_" + item.date.format("YYYY-MM-DD") + "'><h3>" + day_name + "</h3></div>");
        let list_item = document.createElement("div");
        list_item.id = "div_" + item.date.format("YYYY-MM-DD");

        let list_item_title = document.createElement("h3");
        list_item_title.innerHTML = day_name;
        list_item.appendChild(list_item_title);
        div_list.appendChild(list_item);

        //al list_item tengo que hacerle un apend del template

        let a = document.createElement("a");
        a.addEventListener(
          "click",
          (event) => {
            cs_load_game(item.id);
          },
          true
        );
        // a.href = "javascript:cs_load_game(" + item.id + ")";

        //a.onclick = cs_load_game(item.id);

        //first row

        let row_1 = document.createElement("div");
        row_1.classList.add("row");

        let row_1_col_1 = document.createElement("div");
        row_1_col_1.classList.add("col-lg-6", "col-md-6", "col-sm-0");
        let row_1_col_2 = document.createElement("div");
        row_1_col_2.classList.add(
          "col-lg-4",
          "col-md-4",
          "col-sm-12",
          "text-center"
        );
        row_1_col_2.innerHTML = item.venue;
        let row_1_col_3 = document.createElement("div");
        row_1_col_3.classList.add("col-lg-2", "col-md-2", "col-sm-0");

        row_1.appendChild(row_1_col_1);
        row_1.appendChild(row_1_col_2);
        row_1.appendChild(row_1_col_3);

        //second row

        let row_2 = document.createElement("div");
        row_2.classList.add("row");

        //first colum
        let row_2_col_1 = document.createElement("div");
        row_2_col_1.classList.add("col-lg-2", "col-md-2", "col-sm-6");

        let row_2_col_1_div = document.createElement("div");
        row_2_col_1_div.classList.add("cs_time_icon", "cs_time_icon");

        let row_2_col_1_span = document.createElement("span");
        row_2_col_1_span.innerHTML = item.time_start.format("hh:mma");
        row_2_col_1_div.appendChild(row_2_col_1_span);
        row_2_col_1.appendChild(row_2_col_1_div);

        let row_2_col_2 = document.createElement("div");
        row_2_col_2.classList.add("col-lg-2", "col-md-2", "col-sm-6");
        let row_2_col_2_div = document.createElement("div");
        row_2_col_2_div.classList.add(linkClass);
        row_2_col_2_div.style.verticalAlign = "middle";
        row_2_col_2_div.onclick = cs_load_live_game(item.id);
        row_2_col_2_div.id = "btn_live_list";
        let i = document.createElement("i");
        i.classList.add("fi-video");
        i.style.paddingRight = "5px";
        row_2_col_2_div.innerHTML = "Ver en Vivo";
        row_2_col_2_div.prepend(i);

        let row_2_col_3 = document.createElement("div");
        row_2_col_3.classList.add(
          "col-lg-2",
          "col-md-2",
          "col-sm-4",
          "game_list_item_team_1"
        );
        let img = document.createElement("img");
        img.style.maxWidth = "130px";
        img.src = base_url + item.full_url_logo_1;
        row_2_col_3.append(img);

        let row_2_col_4 = document.createElement("div");
        row_2_col_4.classList.add(
          "col-lg-4",
          "col-md-4",
          "col-sm-4",
          "text-center"
        );
        let br = document.createElement("br");
        row_2_col_4.innerHTML = "VS";
        row_2_col_4.prepend(br);

        let row_2_col_5 = document.createElement("div");
        row_2_col_5.classList.add(
          "col-lg-2",
          "col-md-2",
          "col-sm-4",
          "game_list_item_team_2"
        );
        img = document.createElement("img");
        img.src = base_url + item.full_url_logo_2;
        img.style.maxWidth = "130px";
        row_2_col_5.append(img);

        row_2.appendChild(row_2_col_1);
        row_2.appendChild(row_2_col_2);
        row_2.appendChild(row_2_col_3);
        row_2.appendChild(row_2_col_4);
        row_2.appendChild(row_2_col_5);

        //so styles are added to the div
        let link_container = document.createElement("div");
        link_container.classList.add("game_list_item");
        link_container.appendChild(row_1);
        link_container.appendChild(row_2);

        a.appendChild(link_container);
        div_list.appendChild(a);
      }
    });
  } else {
    //$("#lst_games").append("<li class='cs_item cs_message'>No hay eventos en las fechas seleccionadas.</li>");
  }

  return div_list;

  // $('html, body').animate({
  //     scrollTop: $("#div_list").offset().top
  // }, 500);
}

function cs_load_live_game(id) {
  //go to live video
  //window.location.href = "videos.html?id_game=" + id;
}

(() => {})();
